export const ModeofInhertinceOptions = [
  "Autosomal dominant inheritance",
  "Autosomal recessive inheritance",
  "Mitochondrial inheritance",
  "Somatic mutation",
  "Genetic anticipation",
  "Sporadic",
  "Sex-limited autosomal dominant",
  "X-linked recessive inheritance",
  "X-linked dominant inheritance",
  "Y-linked inheritance",
  "Other",
  "X-linked inheritance",
  "Codominant",
  "Semidominant inheritance",
  "Autosomal unknown",
  "Autosomal dominant inheritance with maternal imprinting",
  "Autosomal dominant inheritance with paternal imprinting",
  "Multifactorial inheritance",
  "Unknown mechanism",
  "Oligogenic inheritance",
];
export const ClinicalSignificanceDescriptionOptions = [
  { value: "Pathogenic", label: "Pathogenic" },
  { value: "Likely pathogenic", label: "Likely pathogenic" },
  { value: "Uncertain significance", label: "Uncertain significance" },
  { value: "Likely benign", label: "Likely benign" },
  { value: "Benign", label: "Benign" },
  { value: "affects", label: "Affects" },
  { value: "association", label: "Association" },
  { value: "drug response", label: "Drug response" },
  { value: "confers sensitivity", label: "Confers sensitivity" },
  { value: "protective", label: "Protective" },
  { value: "Pathogenic, low penetrance", label: "Pathogenic, low penetrance" },
  { value: "Uncertain risk allele", label: "Uncertain risk allele" },
  {
    value: "Likely pathogenic, low penetrance",
    label: "Likely pathogenic, low penetrance",
  },
  { value: "Established risk allele", label: "Established risk allele" },
  { value: "Likely risk allele", label: "Likely risk allele" },
  { value: "other", label: "Other" },
  { value: "not provided", label: "Not provided" },
];

export const DbOptions = ["PubMed", "BookShelf", "DOI", "pmc"];
export const assertionCriteriaDbs = ["PubMed", "DOI", "pmc"];
export const ReleaseStatusOptions = ["public", "hold until published"];
export const RecordStatusOptions = ["novel", "update"];

export const AffectedStatusOptions = [
  "yes",
  "no",
  "unknown",
  "not provided",
  "not applicable",
];

export const AlleleOriginOptions = [
  "germline",
  "somatic",
  "de novo",
  "unknown",
  "inherited",
  "maternal",
  "paternal",
  "biparental",
  "not applicable",
];

export const CollectionMethodOptions = [
  "curation",
  "literature only",
  "reference population",
  "provider interpretation",
  "phenotyping only",
  "case-control",
  "clinical testing",
  "in vitro",
  "in vivo",
  "research",
  "not provided",
];

export const StructVarMethodTypeOptions = [
  "SNP array",
  "Oligo array",
  "Read depth",
  "Paired-end mapping",
  "One end anchored assembly",
  "Sequence alignment",
  "Optical mapping",
  "Curated,PCR",
];

export const ConditionSetDBOptions = [
  "OMIM",
  "MedGen",
  "Orphanet",
  "MeSH",
  "HP",
  "MONDO",
];

export const MultipleConditionsExplanations = [
  "Novel disease",
  "Uncertain",
  "Co-occuring",
];

export const ChromosomeCoordinatesAssemblyOptions = [
  "GRCh38",
  "hg38",
  "GRCh37",
  "hg19",
  "NCBI36",
  "hg18",
];

export const VariantTypeOptions = [
  "Insertion",
  "Deletion",
  "Duplication",
  "Tandem duplication",
  "copy number loss",
  "copy number gain",
  "Inversion",
  "Translocation",
  "Complex",
];

export const ChromosomeOptions = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "X",
  "Y",
  "MT",
];

export const DATA_TIP_TEXT = "How can I submit to ClinVar?";
export const CONTRIBUTING_TO_VARSOME_URL =
  "https://docs.varsome.com/en/how-can-i-submit-to-clinvar";

export const filterOptions = ["Pending", "Processed", "Error"];

export const CLINICAL_FEATURES_AFFECTED_STATUS = [
  { value: "present", label: "Present" },
  { value: "absent", label: "Absent" },
  { value: "not tested", label: "Not tested" },
];
